export default {
    listagem: {
        titulo_pagina: 'Lista de materiales',
        novo: 'Crear Nuevo Material',
        habilitado: 'Capaz',
        desabilitado: 'Desactivado',
        table: {
            empty: 'No se encontró material',
            nome: 'Nombre',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Material',
            editar: 'Editar Material'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código del Material'
            },
            nome: {
                label: 'Nombre',
                description: 'Nombre del Material'
            },
            status: {
                label: 'Estado',
                description: 'Estado activo o inactivo del Material'
            },
            botao_salvar : 'Guardar Material'
        },
        create: {
            success: '¡Material creado con éxito!',
            error: '¡Error al crear material!'
        },
        update: {
            success: '¡Material editado con éxito!',
            error: '¡Error al editar el material!'
        }
    }
}
